import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import {
  themes,
  utils,
  Clinic,
  TimeSlot,
  AppointmentType,
  Appointment,
  isAppointmentType
} from 'kb-shared';
import Button from '../../../components/Button/NewButton';
import TermsDetails from './TermsDetails';
import AppointmentDetailBlock from './AppointmentDetailBlock';

const { colors } = themes;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${colors.KBNight};
  margin-top: 1em;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px;
`;

const CopyShared = css`
  ${themes.fonts.DomaineDisplay};
  text-align: center;
`;

const Price = styled.h2`
  ${CopyShared};
  font-size: 36px;
  color: ${colors.KBWhite};
  margin: 0 0 30px 0;
`;

const InsuranceContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 20px;
`;

const Header = styled.h2`
  ${CopyShared};
  font-size: 36px;
  margin: 0;
  color: ${colors.KBWhite};
`;

const SmallPrint = styled.p`
  ${CopyShared};
  font-size: 16px;
  padding: 0 10%;
  color: ${colors.KBLightBlueGrey};
  margin: 16px 0;
`;

type Props = {
  appointment: AppointmentType | Appointment | null;
  timeSlot: TimeSlot | null;
  clinic: Clinic | null; //optional for virtual appointments
  loading: boolean;
  termsAccepted: boolean;
  isReschedule: boolean;
  onTermsAcceptToggled: () => void;
  discountPrice: number | null;
};

export default class ConfirmAppointmentDetails extends Component<Props> {
  renderPrice() {
    const { appointment, discountPrice, isReschedule } = this.props;
    // Do not show price if user is rescheduling
    if (isReschedule) {
      return null;
    }

    if (!isAppointmentType(appointment)) return null;

    if (utils.isGYNAppointment(parseInt(appointment.category.id), process.env.REACT_APP_ENV)) {
      return null;
    }

    const requiresImmediatePayment = utils.requiresPaymentAtBooking(
      parseInt(appointment.category.id),
      process.env.REACT_APP_ENV
    );
    const isAppointmentFree = appointment.rateCents === 0;

    // If we don't require payment right away render insurance copy
    if (!requiresImmediatePayment && !isAppointmentFree) {
      return (
        <InsuranceContainer>
          <Header>Payment Due at Appointment</Header>
          <SmallPrint>
            *Subject to insurance coverage. If not covered, you will be responsible for the total +
            lab work.
          </SmallPrint>
        </InsuranceContainer>
      );
    }

    let priceString = `$${(discountPrice || appointment.rateCents) / 100} due at appointment`;
    if (discountPrice === 0 || isAppointmentFree) {
      priceString = 'Free of charge';
    } else if (requiresImmediatePayment) {
      priceString = `$${(discountPrice || appointment.rateCents) / 100} due today`;
    }

    return <Price>{priceString}</Price>;
  }

  render() {
    const {
      appointment,
      clinic,
      loading,
      onTermsAcceptToggled,
      termsAccepted,
      timeSlot,
      isReschedule
    } = this.props;
    const buttonText = isReschedule ? 'CONFIRM & RESCHEDULE' : 'CONFIRM & BOOK';
    return (
      <Container>
        <Content>
          {isAppointmentType(appointment) && (
            <AppointmentDetailBlock appointment={appointment} timeSlot={timeSlot} clinic={clinic} />
          )}
          {this.renderPrice()}
          <TermsDetails selected={termsAccepted} onCheckBoxSelected={onTermsAcceptToggled} />
          <Button
            loading={loading}
            disabled={loading || !termsAccepted}
            type="submit"
            text={buttonText}
          />
        </Content>
      </Container>
    );
  }
}
